import { motion, useScroll, useSpring } from "framer-motion";
import { useRef } from "react";
import { PROCESS } from "../../data";

export default function ProcessTimeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end center"],
  });
  const height = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });

  return (
    <div ref={ref} className="relative mx-auto max-w-3xl">
      {/* track */}
      <div className="absolute left-[27px] top-2 bottom-2 w-px bg-white/10 md:left-1/2" />
      <motion.div
        style={{ scaleY: height, transformOrigin: "top" }}
        className="absolute left-[27px] top-2 bottom-2 w-px bg-blue-500 shadow-[0_0_12px_rgba(37,99,235,0.8)] md:left-1/2"
      />

      <div className="space-y-10">
        {PROCESS.map((p, i) => (
          <motion.div
            key={p.step}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className={`relative flex items-start gap-6 md:w-1/2 ${
              i % 2 === 0 ? "md:ml-auto md:pl-12" : "md:mr-auto md:flex-row-reverse md:pr-12 md:text-right"
            }`}
            data-testid={`process-step-${p.step}`}
          >
            <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-blue-500/40 bg-[#050505] font-display text-lg font-semibold text-blue-400">
              {p.step}
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-xl">
              <h3 className="font-display text-xl font-medium tracking-tight">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{p.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
